import { importPatients } from 'api/Admin/PatientImports';

import { GENERIC_ERROR } from 'lib/constants/messages';

import { showAlert } from 'components/shared/Alert/Alert';

import correctInsuranceRelation from './correctInsuranceRelation';

export default async function ({
  show,
  setShow,
  headerValue,
  file,
  id,
  navigate,
  patientDetailsFormat
}) {
  let allPatientsData = [...file.data];

  const newShow = {};
  setShow((prevState) => ({ ...prevState, loading: true }));
  try {
    const patientDataConfig = {};
    headerValue.forEach((v, i) => {
      if (v) {
        patientDataConfig[v.value] = i;
      }
    });

    if (patientDataConfig.dob >= 0) {
      patientDataConfig['dobFormat'] = patientDetailsFormat?.dobFormat?.value;
      if (!patientDetailsFormat?.dobFormat?.value) {
        throw 2;
      }
    }

    if (patientDataConfig.full_street_address >= 0) {
      patientDataConfig['addressFormat'] = patientDetailsFormat?.addressFormat?.value;
      if (!patientDetailsFormat?.addressFormat?.value) {
        throw 10;
      }
    }

    if (patientDataConfig.name >= 0) {
      patientDataConfig['nameFormat'] = patientDetailsFormat?.patientName?.value;
      if (!patientDetailsFormat?.patientName?.value) {
        throw 3;
      }
    }

    if (patientDataConfig.insurance_policy_start_date >= 0) {
      patientDataConfig['policyStartDateFormat'] =
        patientDetailsFormat?.policyStartDateFormat?.value;
      if (!patientDetailsFormat?.policyStartDateFormat?.value) {
        throw 4;
      }
    }

    if (patientDataConfig.insurance_policy_end_date >= 0) {
      patientDataConfig['policyEndDateFormat'] = patientDetailsFormat?.policyEndDateFormat?.value;
      if (!patientDetailsFormat?.policyEndDateFormat?.value) {
        throw 5;
      }
    }

    // calling function to correct the insurance relation
    if (patientDataConfig.insurance_relation >= 0) {
      allPatientsData = await correctInsuranceRelation(
        patientDataConfig.insurance_relation,
        file.data
      );

      allPatientsData?.forEach((patient) => {
        if (
          patient[patientDataConfig.insurance_relation] &&
          patient[patientDataConfig.insurance_relation] != 18
        ) {
          const otherRelationFirstName = patient['insured_first_name'];
          const otherRelationLastName = patient['insured_last_name'];
          const otherRelationDate = patient['insurance_other_relation_date'];
          const otherRelationPhone = patient['insurance_other_relation_phone'];
          const otherRelationAddress = patient['insurance_relation_address'];
          if (
            (!otherRelationFirstName && !otherRelationLastName) ||
            !otherRelationDate ||
            !otherRelationPhone ||
            !otherRelationAddress
          ) {
            throw 6;
          }
        }
      });
    }

    if (patientDataConfig.appointment_provider >= 0) {
      patientDataConfig['providerNameFormat'] = patientDetailsFormat?.providerName?.value;
      if (!patientDetailsFormat?.providerName?.value) {
        throw 7;
      }
    }

    if (patientDataConfig.transaction_amount >= 0) {
      patientDataConfig['transactionAmountFormat'] =
        patientDetailsFormat?.transactionAmountFormat?.value;
      if (!patientDetailsFormat?.transactionAmountFormat?.value) {
        throw 8;
      }
    }

    if (patientDataConfig.transaction_amount_paid_self >= 0) {
      patientDataConfig['transactionAmountSelfFormat'] =
        patientDetailsFormat?.transactionAmountSelfFormat?.value;
      if (!patientDetailsFormat?.transactionAmountSelfFormat?.value) {
        throw 9;
      }
    }

    const payload = {
      practiceId: id,
      patientData: allPatientsData,
      patientDataConfig,
      fileName: file.fileName,
      generateEmails: show.generateEmails,
      defaultService: show.defaultService,
      defaultProvider: show.defaultProvider
    };

    const res = await importPatients(navigate, payload);
    const { code, redirect, error } = res;
    switch (code) {
      case -1:
        navigate(redirect);
        newShow['loading'] = false;
        break;
      case 0:
        newShow.stage = 'fileSuccess';
        newShow.loading = false;
        break;
      default:
        showAlert({
          color: 'danger',
          message: error || GENERIC_ERROR
        });
        break;
    }
  } catch (error) {
    if (typeof error === 'number') {
      switch (error) {
        case 2:
          showAlert({
            color: 'danger',
            message: `Select a DOB format`
          });
          break;
        case 3:
          showAlert({
            color: 'danger',
            message: `Select a name format`
          });
          break;
        case 4:
          showAlert({
            color: 'danger',
            message: `Select a policy start date format`
          });
          break;
        case 5:
          showAlert({
            color: 'danger',
            message: `Select a policy end date format`
          });
          break;
        case 6:
          showAlert({
            color: 'danger',
            message: `Other insurance relation information is required`
          });
          break;
        case 7:
          showAlert({
            color: 'danger',
            message: `Select a provider name format`
          });
          break;
        case 8:
          showAlert({
            color: 'danger',
            message: `Select a currency format`
          });
          break;
        case 9:
          showAlert({
            color: 'danger',
            message: `Select a currency format`
          });
          break;
        case 10:
          showAlert({
            color: 'danger',
            message: `Select an address format`
          });
          break;
        default:
          break;
      }
    } else {
      console.error(error);
      showAlert({
        color: 'danger',
        message: GENERIC_ERROR
      });
    }
    newShow.loading = false;
  }
  setShow((prevState) => ({ ...prevState, ...newShow, loading: false }));
}
